import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const QualityControlIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      {...props}
      fill="none"
    >
      <path
        d="M12.3655 14.997L14.6157 17.2459L19.1123 12.748"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2816 24.9612C20.7877 24.9612 25.2509 20.498 25.2509 14.9918C25.2509 9.48562 20.7877 5.02246 15.2816 5.02246C9.7753 5.02246 5.31213 9.48562 5.31213 14.9918C5.31213 20.498 9.7753 24.9612 15.2816 24.9612Z"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3992 25.3119C27.3992 26.3417 26.5645 27.1764 25.5345 27.1764C24.5048 27.1764 23.6688 26.3417 23.6688 25.3119C23.6688 24.282 24.5048 23.4473 25.5345 23.4473C26.5645 23.4473 27.3992 24.282 27.3992 25.3119Z"
        stroke={props.fill || "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QualityControlIcon;
